import {
    Button, Col, DatePicker, Row, Select, Spin,
} from 'antd';
import React from 'react';
import { AiOutlineReload } from 'react-icons/ai';
import { SnapshotGroupBy } from '../interfaces';
import { OnDateChange, WorkspaceOption } from '../models';

const { RangePicker }: any = DatePicker;
const { Option } = Select;

interface Props {
    rangeValue: any;
    onDateChange: OnDateChange;
    disabledDate: (current: any) => boolean;
    workspaceOptions: WorkspaceOption[];
    loadingWorkspaces: boolean;
    groupBy: string;
    selectedWorkspaceID?: string;
    onWorkspaceSearch: (value: string) => void;
    onWorkspaceScroll: (e: React.UIEvent<HTMLDivElement>) => void;
    onWorkspaceDropdownVisibleChange: (open: boolean) => void;
    onWorkspaceChange: (id: string) => void;
    onGroupByChange: (value: SnapshotGroupBy) => void;
    onReload: () => void;
    loadingWorkspace: boolean;
}

const FiltersBar: React.FC<Props> = ({
    rangeValue,
    onDateChange,
    disabledDate,
    workspaceOptions,
    loadingWorkspaces,
    selectedWorkspaceID,
    groupBy,
    onWorkspaceSearch,
    onWorkspaceScroll,
    onWorkspaceDropdownVisibleChange,
    onWorkspaceChange,
    onGroupByChange,
    onReload,
    loadingWorkspace,
}) => (
    <Row justify="start" gutter={[16, 16]}>
        <Col>
            <Select
                placeholder="Select group by..."
                value={groupBy as SnapshotGroupBy}
                onChange={onGroupByChange}
            >
                <Option key="hour" value={SnapshotGroupBy.HOUR}>Por hora</Option>
                <Option key="day" value={SnapshotGroupBy.DAY}>Por día</Option>
                <Option key="week" value={SnapshotGroupBy.WEEK}>Por semana</Option>
                <Option key="booking" value={SnapshotGroupBy.BOOKING}>Por booking</Option>
            </Select>
        </Col>
        <Col>
            <RangePicker
                value={rangeValue}
                onChange={onDateChange}
                disabledDate={disabledDate}
            />
        </Col>
        <Col>
            <Select
                placeholder="Select workspaces..."
                loading={loadingWorkspaces || loadingWorkspace}
                allowClear
                showSearch
                filterOption={false}
                onSearch={onWorkspaceSearch}
                onPopupScroll={onWorkspaceScroll}
                onDropdownVisibleChange={onWorkspaceDropdownVisibleChange}
                notFoundContent={loadingWorkspaces ? <Spin size="small" /> : null}
                value={loadingWorkspace ? 'Loading...' : selectedWorkspaceID || undefined}
                onChange={onWorkspaceChange}
                style={{ minWidth: 320 }}
            >
                {workspaceOptions.map((ws) => (
                    <Option key={ws._id} value={ws._id}>
                        {ws.name}
                    </Option>
                ))}
            </Select>
        </Col>
        <Col>
            <Button
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                type="primary"
                icon={<AiOutlineReload />}
                onClick={onReload}
            />
        </Col>
    </Row>
);

export default FiltersBar;
